import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import FileCopyIcon from '@assets/icons/copy.svg';
import copyText from '@utils/copy';
import useStyles from '../styles';

const DNSTable = ({ records }) => {
  const classes = useStyles();
  const handleCopy = async value => {
    await copyText(value);
  };

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={`${classes.tableHeader} ${classes.typeCell}`}>
              Type
            </TableCell>
            <TableCell className={`${classes.tableHeader} ${classes.nameCell}`}>
              Name
            </TableCell>
            <TableCell
              className={`${classes.tableHeader} ${classes.contentCell}`}
            >
              Content
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map(record => (
            <TableRow
              key={`${record.type}-${record.name}-${record.content}`}
              className={classes.tableRow}
            >
              <TableCell className={`${classes.tableCell} ${classes.typeCell}`}>
                {record.type}
              </TableCell>
              <TableCell className={`${classes.tableCell} ${classes.nameCell}`}>
                <div className={classes.contentWrapper}>
                  <Tooltip title={record.name} placement="top">
                    <div className={classes.contentText}>{record.name}</div>
                  </Tooltip>
                  <Tooltip title="Copy name" placement="top">
                    <IconButton
                      onClick={() => handleCopy(record.name)}
                      className={classes.copyButton}
                      size="small"
                      aria-label="copy name to clipboard"
                    >
                      <img
                        src={FileCopyIcon}
                        alt="Copy"
                        className={classes.copyIcon}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell
                className={`${classes.tableCell} ${classes.contentCell}`}
              >
                <div className={classes.contentWrapper}>
                  <Tooltip title={record.content} placement="top">
                    <div className={classes.contentText}>{record.content}</div>
                  </Tooltip>
                  <Tooltip title="Copy content" placement="top">
                    <IconButton
                      onClick={() => handleCopy(record.content)}
                      className={classes.copyButton}
                      size="small"
                      aria-label="copy content to clipboard"
                    >
                      <img
                        src={FileCopyIcon}
                        alt="Copy"
                        className={classes.copyIcon}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

DNSTable.propTypes = {
  records: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default DNSTable;
